import { Pages } from '@/data/enums/Pages';
import { useRoute } from '@/data/hooks';
import { NS_STEPPER } from '@/i18n/namespaces';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle } from 'react-icons/fa';
import { FaArrowLeft } from 'react-icons/fa';
import { Fragment } from 'react/jsx-runtime';

type PageStepperProps = {
  onBack: () => void;
};

export const PageStepper = ({ onBack }: PageStepperProps) => {
  const pages = [
    Pages.Plan,
    Pages.Questionnaire,
    Pages.Application,
    Pages.Review,
  ];
  const { step } = useRoute();
  const pageIndex = pages.indexOf(step);
  const { t } = useTranslation(NS_STEPPER);

  return (
    <>
      <div className="hidden flex-row items-center justify-center gap-4 p-6 md:flex">
        {pages.map((page, i) => {
          const isAfter = i > pageIndex;
          const isCurrent = i === pageIndex;
          return (
            <Fragment key={page}>
              {/* desktop */}
              <div className="flex items-center gap-3">
                {isAfter ? (
                  <>
                    <div className="flex size-6 items-center justify-center rounded-full bg-[#D9D9D9]">
                      {/* gray out number circle */}
                      <span className="text-sm text-black">{i + 1}</span>
                    </div>
                    <span className="text-base">{t(page)}</span>
                  </>
                ) : isCurrent ? (
                  <>
                    <div className="flex size-6 items-center justify-center rounded-full bg-[#FFBF00]">
                      {/* orange number circle */}
                      <span className="text-sm font-bold text-black">
                        {i + 1}
                      </span>
                    </div>
                    <span className="text-base font-bold">{t(page)}</span>
                  </>
                ) : (
                  <>
                    <div className="flex items-center justify-center">
                      {/* green tick */}
                      <FaCheckCircle className="size-6 fill-success" />
                    </div>
                    <span className="text-base">{t(page)}</span>
                  </>
                )}
              </div>

              {i !== pages.length - 1 && (
                <div className="hidden w-4 border border-black md:block"></div>
              )}
            </Fragment>
          );
        })}
      </div>

      {/* mobile */}
      <div className="sticky top-0 z-10 flex items-center justify-between border-b-[0.5px] bg-white p-4 text-center text-base font-semibold md:hidden">
        <FaArrowLeft role="button" className="size-6" onClick={onBack} />
        <span>
          {t('step', {
            pageNumber: pageIndex + 1,
            totalPageNumber: pages.length,
            page: t(pages[pageIndex]),
          })}
        </span>
        <div className="size-6"></div>
      </div>
    </>
  );
};
